import Header from '../components/Header/Header';
import SeperateHero from '../components/SpecialJoin/SeperateHero';
import Banner from '../components/Banner/Banner';
import CareerComponent from '../components/CareerComponent/CareerComponent';
import BreadcrumbSchema from "./BreadcrumbSchema";

function Carrier() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500/10 to-purple-500/10">
      <BreadcrumbSchema />
      <Header />

      {/* Add margin-top for spacing below header */}
      <div className="mt-16">
        <Banner />
      </div>

      <CareerComponent />
      <SeperateHero />
    </div>
  );
}

export default Carrier;
